import router, { constantRoutes } from "@/router";

// import Layout from "@/layout";

// 动态加载业务页面。
// 当菜单配置的 .vue 文件还不存在（功能尚未开发）时，import 会抛出
// MODULE_NOT_FOUND 错误，此时回退到“功能开发中”提示页，避免白屏 / 崩溃。
function loadView(component) {
  if (!component || component === "/layout") {
    return () => import("@/layout/index.vue");
  }
  return () =>
    import("@/views" + component + ".vue").catch((err) => {
      const isMissing =
        err &&
        (err.code === "MODULE_NOT_FOUND" ||
          /Cannot find module/.test(err.message || ""));
      if (isMissing) {
        return import("@/views/under-development/index.vue");
      }
      // 非“文件缺失”的其它加载错误（例如语法错误）继续抛出，便于开发阶段排查
      return Promise.reject(err);
    });
}

export function generateAsyncRoutes(menus) {
  // console.log(menus)
  const res = [];

  menus.forEach((menu) => {
    if (menu.component && menu.path) {
      const tmp = {
        path: menu.path,
        component: loadView(menu.component),
        name: menu.name,
        meta: menu.meta,
      };

      if (menu.children) {
        tmp.children = generateAsyncRoutes(menu.children);
      }

      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [], //当前用户的路由地址
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes; //添加的路由
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, menus) {
    return new Promise((resolve) => {
      let accessedRoutes;
      accessedRoutes = generateAsyncRoutes(menus);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
